<template>
    <v-card class="p-3">
        <h5>Historique</h5>

        <v-timeline
          align-top
          dense
        >
            <v-timeline-item
              v-for="action in actions"
              :color="getActionColor(action.type.name)"
              small
              fill-dot
            >
                <div class="border rounded p-3">
                    <strong
                      style="font-size: 15px"
                      :class="'text-' + getActionColor(action.type.name)"
                    >{{ action.type.label }}</strong
                    >
                    <div class="d-flex justify-content-between align-items-top">
                        <div>
                            <div v-if="action.actionable !== null">
                                <div v-if="action.actionable_type === 'App\\Models\\WebForm\\WebForm'">
                                    <div v-if="action.actionable.cmaj_batch_id === null">Demande individuelle</div>
                                    <div v-else-if="action.actionable.cmaj_batch !== null">
                                        {{ action.actionable.cmaj_batch.cmaj.name }}
                                    </div>
                                </div>
                                <div v-else-if="action.actionable_type === 'App\\Models\\WebForm\\Answer'">
                                    <div v-if="action.actionable.web_form.cmaj_batch_id === null && vtContract">
                                        Veille Tourisme - Mise à jour Google
                                    </div>
                                    <div v-else-if="action.actionable.web_form.cmaj_batch_id === null &&
                                     action.actionable.web_form.origin === 'USKA'">
                                        Formulaire ouvert Uska
                                    </div>
                                    <div v-else-if="action.actionable.web_form.cmaj_batch_id === null">
                                        Demande individuelle
                                    </div>
                                    <div v-else-if="action.actionable.cmaj_batch !== null">
                                        {{ action.actionable.web_form.cmaj_batch.cmaj.name }}
                                    </div>
                                </div>
                                <div v-else-if="action.actionable_type === 'App\\Models\\CADH\\CadhForm'">
                                    <div v-if="action.actionable.cadh_batch_id === null">Demande individuelle</div>
                                    <div v-else-if="action.actionable.cmaj_batch !== null">
                                        {{ action.actionable.batch.cadh.name }}
                                    </div>
                                </div>
                                <div v-else-if="action.actionable_type === 'App\\Models\\Provider\\ContactEmailChange'">
                                    <div>
                                        <span>Ancien e-mail : </span>
                                        <span v-if="action.actionable.old_email">{{ action.actionable.old_email
                                            }}</span>
                                        <span v-else> aucun </span>
                                    </div>
                                    <div>
                                        <span>Nouvel e-mail : </span>
                                        <span v-if="action.actionable.new_email">{{ action.actionable.new_email
                                            }}</span>
                                        <span v-else> aucun </span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="action.actionable_type === 'App\\Models\\WebForm\\WebForm' ||
                                 action.actionable_type === 'App\\Models\\CADH\\CadhForm'">
                                    <span>Campagne supprimée</span>
                                </div>
                            </div>
                            <small>Le {{ formatDate(action.created_at) }}</small>
                        </div>
                        <div>
                            <router-link
                              :to="'/answer/' + action.actionable.web_form.token"
                              v-if="action.type.name === 'WEB_FORM_ANSWERED' && action.actionable !== null"
                            >
                                Voir la réponse
                            </router-link>
                            <router-link
                              :to="getCadhAnswerLink(action)"
                              v-if="(action.type.name === 'CADH_FORM_ANSWERED' || action.type.name === 'INVOICE_SENT')
                && action.actionable !== null && action.actionable.contact_token !== null"
                            >
                                Voir la réponse
                            </router-link>

                            <a
                              :href="'/espace-pro/' + action.actionable.contact_token + '/formulaire/' + action.actionable.token"
                              target="_blank"
                              v-else-if="
                  (action.type.name === 'WEB_FORM_SENT' || action.type.name === 'WEB_FORM_SENT_USKA') &&
                  action.actionable !== null && action.actionable.contact_token !== null
                "
                            >
                                Voir le formulaire
                            </a>

                            <a
                              :href="getCadhLink(action)"
                              target="_blank"
                              v-else-if="action.type.name === 'CADH_FORM_SENT' && action.actionable !== null && action.actionable.contact_token !== null"
                            >
                                Voir le formulaire
                            </a>
                        </div>
                    </div>
                </div>
            </v-timeline-item>
        </v-timeline>
    </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "HistoryBloc",
    props: ["actions", "provider"],
    data() {
        return {
            cadhFrontUrl: process.env.VUE_APP_CADH_URL,
            actionColors: [
                { type: "IMPORTED", color: "grey" },
                { type: "SENT_APIDAE", color: "primary" },
                { type: "WEB_FORM_SENT", color: "grey" },
                { type: "CADH_FORM_SENT", color: "grey" },
                { type: "WEB_FORM_ANSWERED", color: "warning" },
                { type: "CADH_FORM_ANSWERED", color: "warning" },
                { type: "UPDATED_ANSWER", color: "purple" },
                { type: "VALIDATED_PAYMENT", color: "success" },
                { type: "VALIDATED_ADH", color: "success" },
                { type: "REFUSED_ADH", color: "error" },
                { type: "INVOICE_SENT", color: "purple" },
            ],
        }
    },
    methods: {
        getActionColor(actionName) {
            let color = "grey"
            let action = this.actionColors.find((action) => action.type === actionName)

            if (action !== null && action !== undefined) {
                color = action.color
            }

            return color
        },
        slugify(str) {
            str = str.replace(/^\s+|\s+$/g, "")
            str = str.toLowerCase()

            let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
            let to = "aaaaeeeeiiiioooouuuunc------"

            for (let i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
            }

            return str
              .replace(/[^a-z0-9 -]/g, "")
              .replace(/\s+/g, "-")
              .replace(/-+/g, "-")
        },
        getCadhLink(action) {

            let url =
              window.location.origin +
              "/espace-pro/" +
              action.actionable.contact_token +
              "/adhesion/" +
              action.actionable.token

            return url
        },
        getCadhAnswerLink(action) {
            return "/adhesion/answer/" + btoa(action.actionable.id)
        },
    },
    computed: {
        ...mapState("account", ["vtContract"]),
    },
}
</script>
